// The agent's plain coaching notice on the call card. Inline SVG headset icon (never a glyph or emoji).
import type { Call } from '@bcio-voice/contracts';
import { PathIcon } from '../../ui/Icon.tsx';
import { agentCoachingNotice } from './coaching.ts';

const HEADSET = ['M3 14v-2a9 9 0 0 1 18 0v2', 'M21 16a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2z', 'M3 16a2 2 0 0 0 2 2h1v-6H5a2 2 0 0 0-2 2z'] as const;

export function CoachingBanner({ call }: { call: Pick<Call, 'state' | 'coaching'> }) {
  const notice = agentCoachingNotice(call);
  if (!notice) return null;
  return (
    <p className={`notice notice-info coaching-notice coaching-${notice.mode}`} role="status" aria-live="polite">
      <PathIcon paths={HEADSET} /> {notice.text}
    </p>
  );
}
